'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastMessage = undefined;

var _getMessages = require('./getMessages');

var lastMessage = exports.lastMessage = function lastMessage(threadHistory) {
  return (0, _getMessages.getMessages)(threadHistory).last();
};